var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82454 0.17546C5.59052 -0.0584865 5.21118 -0.0584865 4.97717 0.17546L3.00375 2.14887L1.03034 0.17546C0.795198 -0.051649 0.421427 -0.048401 0.190266 0.18276C-0.0408942 0.41392 -0.0441421 0.787691 0.182966 1.02283L2.15638 2.99625L0.182966 4.96966C0.027181 5.12012 -0.0352971 5.34293 0.0195459 5.55246C0.0743888 5.76198 0.238018 5.92561 0.447542 5.98045C0.657066 6.0353 0.879879 5.97282 1.03034 5.81703L3.00375 3.84362L4.97717 5.81703C5.21231 6.04414 5.58608 6.04089 5.81724 5.80973C6.0484 5.57857 6.05165 5.2048 5.82454 4.96966L3.85113 2.99625L5.82454 1.02283C6.05849 0.788818 6.05849 0.409476 5.82454 0.17546Z",
    fill: "#7C7C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.3f2b6c09ea7245cf1be2effa75d9e7a2.svg";
export { ForwardRef as ReactComponent };